import React from "react";
import Slider from "react-slick";
import authImg4 from "../../../assets/images/kmc-images/Testimonials/avatar_img.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TestimonialsBlock = () => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const testimonial = [
    {
      name: "Nitya Reddy",
      designation: "Patient",
      content:
        "The place is very neat and hygienic. The entire staff from the nurses, receptionist and Doctors all are very welcoming and warm. I went to extract my nail. The doctor was extremely gentle and considerate throughout the procedure. He is extremely experienced and knows what to do.",
      authImage: authImg4,
    },
    {
      name: "Anupama Kapatkar",
      designation: "Patient",
      content:
        "The Doctor and nurses are very caring and treat with patience. From Kanha Medical Centre we get necessary timely guidance and precautions regarding health care especially Covid 19. We are extremely greatful for all team members of KMC for their selfless services",
      authImage: authImg4,
    },

    {
      name: "Joshua George",
      designation: "Patient",
      content:
        "My sugar level to normal. In view of the criticality, I was referred to a surgeon at Medicare. Sisters at KMC also took utmost care constantly to ensure my quick recovery. The Medical Centre and pharmacy are kept tidy and hygienic  with all required facilities and supplies.",
      authImage: authImg4,
    },
    {
      name: "Jayendran Muthushankar",
      designation: "Patient",
      content:
        "Great Staff, very friendly, take care of all your request for medicines and good follow up to get the medicines for you even it takes a few days to get it from the city. They also deliver to home for people who are sick. All in all staff are working like angels here.",
      authImage: authImg4,
    },
    {
      name: "Sachin Aiwale",
      designation: "Patient",
      content:
        "Excellent experience from reception to physician. All staff is so kinf and helpful. My heartiest thanks the doctor who diagnosed for my sever check pain. Pain stopped within 30 mins of taking medicine from the doctor. I highly recommend this place for people around Kanha village and Chegur.",
      authImage: authImg4,
    },
  ];

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <h2>Testimonials</h2>
        </div>
      </div>
      <div className="row justify-content-center p-4 pt-4">
        <Slider {...settings}>
          {testimonial.map((list) => (
            <div className="col-sm-12 col-md-4 col-lg-4">
              <div className="testimonial-columns text-center">
                <img src={list.authImage} alt="" />
                <p className="pt-3 testimonial-ptag">{list.content}</p>
                <p className="pt-3 mb-0 testimonial-ptag">
                  <b>{list.name}</b>
                </p>
                <p className="testimonial-ptag">{list.designation}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default TestimonialsBlock;
